import axios from 'axios';

const createNewTour = async (listingId: string): Promise<string> => {
  const { data: tourId } = await axios.post(
    `/tours/create_new_tour/${listingId}`,
  );

  return tourId;
};

export default createNewTour;
